import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportGeneral(ctx: any, vrs: number): any {

    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;

    var table_width = 0;
    var vehiculo_width = 0;
    var column_config = [];


    //======================================================================
    var pc_cell_ch_width = "Punto Cercano".length;
    var vel_can_cell_ch_width = "Velocidad".length;
    var vel_gps_cell_ch_width = "Velocidad".length;
    var vel_gps_speed_cell_ch_width = "Velocidad".length;
    var vel_mobileye_cell_ch_width = "Velocidad".length;
    var vel_eco_cell_ch_width = "Velocidad".length;
    var duot2_state_cell_ch_width = "DUOT2 state".length;
    var rev_x_min_cell_ch_width = "Rev.x.min".length;
    var rpm_alta_cell_ch_width = "RPM Alta".length;
    var nivel_de_combustible_cell_ch_width = "Combustible".length;
    var c_restante_cell_ch_width = "C. Restante".length;
    var c_motor_cell_ch_width = "C. Motor".length;
    var odometro_cell_ch_width = "Odometro".length;
    var altitud_cell_ch_width = "Altitud".length;
    var angulo_cell_ch_width = "Angulo".length;

    var alimentacion_gps_cell_ch_width = "Alimentación GPS".length;
    var nivel_bateria_cell_ch_width = "Nivel de Batería".length;
    var nivel_cobertura_cell_ch_width = "Nivel de Cobertura".length;
    var temperatura_gps_cell_ch_width = "Temperatura GPS".length;
    var satelite_cell_ch_width = "Satélite".length;

    var reconocimiento_facial_cell_ch_width = "Reconocimiento".length;
    var on_off_cell_ch_width = "On-off".length;
    var alcoholemia_cell_ch_width = "Alcoholemia".length;
    var parametros_cell_ch_width = "Parametros".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;
    var referencia_cell_ch_width = "Referencia".length;
    var fatiga_cell_ch_width = "Fatiga".length;
    var frenada_extrema_brusca_cell_ch_width = "Extrema brusca".length;
    var frenada_brusca_cell_ch_width = "Frenada".length;
    var acelaracion_brusca_cell_ch_width = "Aceleracion".length;

    //==================================
    var bool_col_fServidor = false;
    var bool_col_pCercano = false;
    var bool_col_velCAN = false;
    var bool_col_velGPS = false;
    var bool_col_velGPS_speed = false;
    var bool_col_velMobileye_ME460 = false;
    var bool_col_velECO = false;
    var bool_col_DUOT2state = false;
    var bool_col_RxM = false;
    var bool_col_RPMAlta = false;
    var bool_col_cNivel = false;
    var bool_col_cRestante = false;
    var bool_col_cMotor = false;
    var bool_col_odometro = false;
    var bool_col_altitud = false;
    var bool_col_angulo = false;

    var bool_col_alimentGps = false;
    var bool_col_nivelBateria = false;
    var bool_col_nivelCobertura = false;
    var bool_col_temperaturaGps = false;
    var bool_col_satelite = false;

    var bool_col_recFacial = false;
    var bool_col_onOff = false;
    var bool_col_alcoholemia = false;
    var bool_col_parametros = false;
    var bool_col_ubicacion = false;
    var bool_col_referencia = false;
    var bool_col_fatiga = false;
    var bool_col_fExBrusca = false;
    var bool_col_fBrusca = false;
    var bool_col_aBrusca = false;



    var header_two_lines = false;

    var allRows: AllRows[] = [
        {
            cells: [
            { value: "REPORTE GENERAL", ...ctx.headerCellConfig, colSpan: 6 }
            ],
            height: ctx.headerRowsHeight,
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];

    ctx.data.forEach((data: any,idx:any) => {

        if(table_width == 0){
        table_width++; //Item
        table_width++; //Fecha
        if(ctx.chkDateHour){ table_width++;  }

        if (data[2].fServidor){
            table_width++;
            bool_col_fServidor = true;
            if(ctx.chkDateHour){ table_width++;  }
        }

        // if (data[2].ubicacion){ table_width++; bool_col_ubicacion = true;  }
        // if (data[2].velGPS){  table_width++; bool_col_velGPS = true;  }
        // if (data[2].velECO){  table_width++; bool_col_velECO = true;  }
        // if (data[2].velGPS_speed){  table_width++; bool_col_velGPS_speed = true;  }
        // if (data[2].velMobileye_ME460){  table_width++; bool_col_velMobileye_ME460 = true;  }

        // if (data[2].altitud){ table_width++; bool_col_altitud = true;  }
        // if (data[2].angulo){  table_width++; bool_col_angulo = true;  }
        // if (data[2].fatiga){  table_width++; bool_col_fatiga = true;  }
        // if (data[2].fExBrusca){ table_width++; bool_col_fExBrusca = true;  header_two_lines = true; }
        // if (data[2].fBrusca){ table_width++; bool_col_fBrusca = true;  header_two_lines = true; }
        // if (data[2].aBrusca){ table_width++; bool_col_aBrusca = true;  header_two_lines = true; }
        // if (data[2].RPMAlta){ table_width++; bool_col_RPMAlta = true;  }

        // if (data[2].alcoholemia){ table_width++; bool_col_alcoholemia = true;  }
        // if (data[2].parametros){  table_width++; bool_col_parametros = true;  }
        // if (data[2].cNivel){  table_width++; bool_col_cNivel = true;  header_two_lines = true; }
        // if (data[2].cRestante){ table_width++; bool_col_cRestante = true;  }
        // if (data[2].cMotor){  table_width++; bool_col_cMotor = true;  }
        // if (data[2].odometro){  table_width++; bool_col_odometro = true;  }
        // if (data[2].onOff){ table_width++; bool_col_onOff = true;  }
        // if (data[2].RxM){ table_width++; bool_col_RxM = true;  }
        // if (data[2].recFacial){ table_width++; bool_col_recFacial = true;  header_two_lines = true; }
        // if (data[2].velCAN){  table_width++; bool_col_velCAN = true;  }
        // if (data[2].pCercano){  table_width++; bool_col_pCercano = true;  }
        // if (data[2].referencia){  table_width++; bool_col_referencia = true;  }
        // if (data[2].DUOT2state){  table_width++; bool_col_DUOT2state = true;  }


        if (data[2].pCercano) { table_width++; bool_col_pCercano = true;  };
        if (data[2].velCAN) { table_width++; bool_col_velCAN = true; };
        if (data[2].velGPS) { table_width++; bool_col_velGPS = true; };
        if (data[2].velGPS_speed) { table_width++; bool_col_velGPS_speed = true; };
        if (data[2].velMobileye_ME460) { table_width++; bool_col_velMobileye_ME460 = true; };
        if (data[2].velECO) { table_width++; bool_col_velECO = true; };
        if (data[2].DUOT2state) { table_width++; bool_col_DUOT2state = true; };
        if (data[2].RxM) { table_width++; bool_col_RxM = true; };
        if (data[2].RPMAlta) { table_width++; bool_col_RPMAlta = true; };
        if (data[2].cNivel) { table_width++; bool_col_cNivel = true; };
        if (data[2].cRestante) { table_width++; bool_col_cRestante = true; };
        if (data[2].cMotor) { table_width++; bool_col_cMotor = true; };
        if (data[2].odometro) { table_width++; bool_col_odometro = true; };
        if (data[2].altitud) { table_width++; bool_col_altitud = true; };
        if (data[2].angulo) { table_width++; bool_col_angulo = true; };

        if (data[2].alimentGps) { table_width++; bool_col_alimentGps = true; };
        if (data[2].nivelBateria) { table_width++; bool_col_nivelBateria = true; };
        if (data[2].nivelCobertura) { table_width++; bool_col_nivelCobertura = true; };
        if (data[2].temperaturaGps) { table_width++; bool_col_temperaturaGps = true; };
        if (data[2].satelite) { table_width++; bool_col_satelite = true; };

        if (data[2].recFacial) { table_width++; bool_col_recFacial = true; };
        if (data[2].onOff) { table_width++; bool_col_onOff = true; };
        if (data[2].alcoholemia) { table_width++; bool_col_alcoholemia = true; };
        if (data[2].parametros) { table_width++; bool_col_parametros = true; };
        if (data[2].ubicacion) { table_width++; bool_col_ubicacion = true; };
        if (data[2].referencia) { table_width++; bool_col_referencia = true; };
        if (data[2].fatiga) { table_width++; bool_col_fatiga = true; };
        if (data[2].fExBrusca) { table_width++; bool_col_fExBrusca = true; };
        if (data[2].fBrusca) { table_width++; bool_col_fBrusca = true; };
        if (data[2].aBrusca) { table_width++; bool_col_aBrusca = true; };



        vehiculo_width = 1 + (ctx.chkDateHour? 2:1) + (data[2].fServidor? (ctx.chkDateHour? 2:1): 0);
        }

        if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
            {
            cells: [
                { value: "REPORTE GENERAL", ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight
            },
            ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
            {
            cells: [
                { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
                { value: "PERIODO", ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: ctx.subHeaderHeight
            },
            {
            cells: [
                { value: data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
                { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: ctx.subHeaderContentHeight
            },
            ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        ];


        //=================CABECERA =================
        var cellsCampos :any = [];

        cellsCampos.push({ value: "Item", ...ctx.colHeaderConfig });

        if(ctx.chkDateHour) {
            cellsCampos.push({ value: "Fecha", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Hora", ...ctx.colHeaderConfig });
        } else {
            cellsCampos.push({ value: "Fecha", ...ctx.colHeaderConfig });
        }

        if (data[2].fServidor) {
                if(ctx.chkDateHour) {
                    cellsCampos.push({ value: "Fecha servidor", ...ctx.colHeaderConfig });
                    cellsCampos.push({ value: "Hora servidor", ...ctx.colHeaderConfig });
                } else {
                    cellsCampos.push({ value: "Fecha servidor", ...ctx.colHeaderConfig });
                }
        };

        if (data[2].pCercano) { cellsCampos.push({ value: "Punto Cercano", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].velCAN) { cellsCampos.push({ value: "Velocidad CAN", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].velGPS) { cellsCampos.push({ value: "Velocidad GPS", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].velGPS_speed) { cellsCampos.push({ value: "Velocidad GPS speed", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].velMobileye_ME460) { cellsCampos.push({ value: "Velocidad Mobileye", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].velECO) { cellsCampos.push({ value: "Velocidad ECO", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].DUOT2state) { cellsCampos.push({ value: "DUOT2 state", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].RxM) { cellsCampos.push({ value: "Rev.X.Min", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].RPMAlta) { cellsCampos.push({ value: "RPM Alta", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].cNivel) { cellsCampos.push({ value: "Nivel de Combustible", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].cRestante) { cellsCampos.push({ value: "C. Restante", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].cMotor) { cellsCampos.push({ value: "C. Motor", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].odometro) { cellsCampos.push({ value: "Odómetro", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].altitud) { cellsCampos.push({ value: "Altitud", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].angulo) { cellsCampos.push({ value: "Angulo", ...ctx.colHeaderConfig, wrap: header_two_lines }); };

        if (data[2].alimentGps) { cellsCampos.push({ value: "Alimentación GPS", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].nivelBateria) { cellsCampos.push({ value: "Nivel de Batería", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].nivelCobertura) { cellsCampos.push({ value: "Nivel de Cobertura", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].temperaturaGps) { cellsCampos.push({ value: "Temperatura GPS", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].satelite) { cellsCampos.push({ value: "Satélite", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].recFacial) { cellsCampos.push({ value: "Reconocimiento Facial", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].onOff) { cellsCampos.push({ value: "On/Off", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].alcoholemia) { cellsCampos.push({ value: "Alcoholemia", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].parametros) { cellsCampos.push({ value: "Parámetros", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].ubicacion) { cellsCampos.push({ value: "Ubicación", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].referencia) { cellsCampos.push({ value: "Referencia", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].fatiga) { cellsCampos.push({ value: "Fatiga", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].fExBrusca) { cellsCampos.push({ value: "Frenada Extrema Brusca", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].fBrusca) { cellsCampos.push({ value: "Frenada Brusca", ...ctx.colHeaderConfig, wrap: header_two_lines }); };
        if (data[2].aBrusca) { cellsCampos.push({ value: "Aceleración Brusca", ...ctx.colHeaderConfig, wrap: header_two_lines }); };




        rows.push({
            cells: cellsCampos,
            height: header_two_lines? ctx.colsHeaderHeightTwoLine: ctx.colsHeaderHeight,
        });

        //================= FIN CABECERA =================

        //====================  CUERPO =============================
        data[1].forEach((item: { satelite:any; temperaturaGps:any; nivelCobertura:any; nivelBateria:any; alimentGps:any;fecha: number;  lat: number; lng: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any;
            vel_gps_speed: any; vel_can: any; tramo: string; PC: any;
        referencia:any; fServidor:any; velGPS:any; velECO:any; velGPS_speed:any; velMobileye_ME460:any; altitud:any; angulo:any; fatiga:any; fExBrusca:any; fBrusca:any; aBrusca:any; RPMAlta:any;
        alcohol_nombre:any; parametros:any; cNivel:any; cRestante:any; cMotor:any; odometro:any; onOff:any; RxM:any; recFacial:any; velCAN:any; pCercano:any; DUOT2state:any;
        }, index: number) => {


            var ubicacion = item.lat.toFixed(6) + "," + item.lng.toFixed(6) + "";
            var rreeff = ((item.referencia == "NN") ? '' : item.referencia);
            var parametros = ctx.breakParameterColValue(item.parametros??'');
            var cellsCuerpo = [];

            //parametros_cell_ch_width = Math.max(parametros_cell_ch_width, (item.parametros??'').toString().length);
            //===========================================================
            pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.velCAN??'').toString().length);
            vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.velCAN??'').toString().length);
            vel_gps_cell_ch_width = Math.max(vel_gps_cell_ch_width, (item.velGPS??'').toString().length);
            vel_gps_speed_cell_ch_width = Math.max(vel_gps_speed_cell_ch_width, (item.velGPS_speed??'').toString().length);
            vel_mobileye_cell_ch_width = Math.max(vel_mobileye_cell_ch_width, (item.velMobileye_ME460??'').toString().length);
            vel_eco_cell_ch_width = Math.max(vel_eco_cell_ch_width, (item.velECO??'').toString().length);
            duot2_state_cell_ch_width = Math.max(duot2_state_cell_ch_width, (item.DUOT2state??'').toString().length);
            rev_x_min_cell_ch_width = Math.max(rev_x_min_cell_ch_width, (item.RxM??'').toString().length);
            rpm_alta_cell_ch_width = Math.max(rpm_alta_cell_ch_width, (item.RPMAlta??'').toString().length);
            nivel_de_combustible_cell_ch_width = Math.max(nivel_de_combustible_cell_ch_width, (item.cNivel??'').toString().length);
            c_restante_cell_ch_width = Math.max(c_restante_cell_ch_width, (item.cRestante??'').toString().length);
            c_motor_cell_ch_width = Math.max(c_motor_cell_ch_width, (item.cMotor??'').toString().length);
            odometro_cell_ch_width = Math.max(odometro_cell_ch_width, (item.odometro??'').toString().length);
            altitud_cell_ch_width = Math.max(altitud_cell_ch_width, (item.altitud??'').toString().length);
            angulo_cell_ch_width = Math.max(angulo_cell_ch_width, (item.angulo??'').toString().length);

            alimentacion_gps_cell_ch_width = Math.max(alimentacion_gps_cell_ch_width, (item.alimentGps??'').toString().length);
            nivel_bateria_cell_ch_width = Math.max(nivel_bateria_cell_ch_width, (item.nivelBateria??'').toString().length);
            nivel_cobertura_cell_ch_width = Math.max(nivel_cobertura_cell_ch_width, (item.nivelCobertura??'').toString().length);
            temperatura_gps_cell_ch_width = Math.max(temperatura_gps_cell_ch_width, (item.temperaturaGps??'').toString().length);
            satelite_cell_ch_width = Math.max(satelite_cell_ch_width, (item.satelite??'').toString().length);

            reconocimiento_facial_cell_ch_width = Math.max(reconocimiento_facial_cell_ch_width, (item.recFacial??'').toString().length);
            on_off_cell_ch_width = Math.max(on_off_cell_ch_width, (item.onOff??'').toString().length);
            alcoholemia_cell_ch_width = Math.max(alcoholemia_cell_ch_width, (item.alcohol_nombre??'').toString().length);
            parametros_cell_ch_width = Math.max(parametros_cell_ch_width, ctx.getChWidth(parametros));
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.pCercano??'').toString().length);
            fatiga_cell_ch_width = Math.max(fatiga_cell_ch_width, (item.fatiga??'').toString().length);
            frenada_extrema_brusca_cell_ch_width = Math.max(frenada_extrema_brusca_cell_ch_width, (item.fExBrusca??'').toString().length);
            frenada_brusca_cell_ch_width = Math.max(frenada_brusca_cell_ch_width, (item.fBrusca??'').toString().length);
            acelaracion_brusca_cell_ch_width = Math.max(acelaracion_brusca_cell_ch_width, (item.aBrusca??'').toString().length);



            cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });
            if(ctx.chkDateHour) {
                cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
            } else {
                cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
            }


            if (data[2].fServidor) {
                if(ctx.chkDateHour) {
                    //var fh2 = item.fServidor.split(" ");
                    cellsCuerpo.push({ value: ctx.isChe(item.fServidor), type: 'date', format: "yyyy/MM/dd", ...ctx.bodyRowsConfig });
                    cellsCuerpo.push({ value: ctx.isChs(item.fServidor), type: 'date', format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                } else {
                    cellsCuerpo.push({ value: ctx.isChe(item.fServidor), type: 'date', format: "yyyy/MM/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                }
            };

            //if (data[2].ubicacion) { cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig }); };
            //==================================================
            if (data[2].pCercano) { cellsCuerpo.push({ value: item.pCercano, ...ctx.bodyRowsConfig }); };
            if (data[2].velCAN) { cellsCuerpo.push({ value: item.velCAN, ...ctx.bodyRowsConfig }); };
            if (data[2].velGPS) { cellsCuerpo.push({ value: item.velGPS, ...ctx.bodyRowsConfig }); };
            if (data[2].velGPS_speed) { cellsCuerpo.push({ value: item.velGPS_speed, ...ctx.bodyRowsConfig }); };
            if (data[2].velMobileye_ME460) { cellsCuerpo.push({ value: item.velMobileye_ME460, ...ctx.bodyRowsConfig }); };
            if (data[2].velECO) { cellsCuerpo.push({ value: item.velECO, ...ctx.bodyRowsConfig }); };
            if (data[2].DUOT2state) { cellsCuerpo.push({ value: item.DUOT2state, ...ctx.bodyRowsConfig }); };
            if (data[2].RxM) { cellsCuerpo.push({ value: item.RxM, ...ctx.bodyRowsConfig }); };
            if (data[2].RPMAlta) { cellsCuerpo.push({ value: item.RPMAlta, ...ctx.bodyRowsConfig }); };
            if (data[2].cNivel) { cellsCuerpo.push({ value: item.cNivel, ...ctx.bodyRowsConfig }); };
            if (data[2].cRestante) { cellsCuerpo.push({ value: item.cRestante, ...ctx.bodyRowsConfig }); };
            if (data[2].cMotor) { cellsCuerpo.push({ value: item.cMotor, ...ctx.bodyRowsConfig }); };
            if (data[2].odometro) { cellsCuerpo.push({ value: item.odometro, ...ctx.bodyRowsConfig }); };
            if (data[2].altitud) { cellsCuerpo.push({ value: item.altitud, ...ctx.bodyRowsConfig }); };
            if (data[2].angulo) { cellsCuerpo.push({ value: item.angulo, ...ctx.bodyRowsConfig }); };

            if (data[2].alimentGps) { cellsCuerpo.push({ value: item.alimentGps, ...ctx.bodyRowsConfig }); };
            if (data[2].nivelBateria) { cellsCuerpo.push({ value: item.nivelBateria, ...ctx.bodyRowsConfig }); };
            if (data[2].nivelCobertura) { cellsCuerpo.push({ value: item.nivelCobertura, ...ctx.bodyRowsConfig }); };
            if (data[2].temperaturaGps) { cellsCuerpo.push({ value: item.temperaturaGps, ...ctx.bodyRowsConfig }); };
            if (data[2].satelite) { cellsCuerpo.push({ value: item.satelite, ...ctx.bodyRowsConfig }); };

            if (data[2].recFacial) { cellsCuerpo.push({ value: item.recFacial, ...ctx.bodyRowsConfig }); };
            if (data[2].onOff) { cellsCuerpo.push({ value: item.onOff, ...ctx.bodyRowsConfig }); };
            if (data[2].alcoholemia) { cellsCuerpo.push({ value: item.alcohol_nombre, ...ctx.bodyRowsConfig }); };
            if (data[2].parametros) { cellsCuerpo.push({ value: parametros, ...ctx.bodyRowsConfig, wrap: true }); };
            if (data[2].ubicacion) { cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig }); };
            if (data[2].referencia) { cellsCuerpo.push({ value: rreeff, ...ctx.bodyRowsConfig }); };
            if (data[2].fatiga) { cellsCuerpo.push({ value: item.fatiga, ...ctx.bodyRowsConfig }); };
            if (data[2].fExBrusca) { cellsCuerpo.push({ value: item.fExBrusca, ...ctx.bodyRowsConfig }); };
            if (data[2].fBrusca) { cellsCuerpo.push({ value: item.fBrusca, ...ctx.bodyRowsConfig }); };
            if (data[2].aBrusca) { cellsCuerpo.push({ value: item.aBrusca, ...ctx.bodyRowsConfig }); };


            rows.push({
                cells:cellsCuerpo,
                height: Math.max(ctx.bodyRowsHeight, ctx.calculateSingleRowHeight(parametros, ctx.bodyRowsHeight))
            });

            console.log(ctx.bodyRowsHeight);
            console.log(ctx.calculateSingleRowHeight(parametros, ctx.bodyRowsHeight));

        });
        //==================== FIN CUERPO =============================

        //==================== RESUMEN =============================
        rows.push(
            ...ctx.spaceBetweenTables,
            {
            cells:[
                { value: "TOTAL de Excesos de Velocidad(GPS) : ", ...ctx.overviewLeftConfig },
                { value: data[3][0], ...ctx.overviewRightConfig, colSpan: 1 }
            ],
            height: ctx.overviewRowsHeight
            },
            {
            cells:[
                { value: "TOTAL de Excesos de Velocidad(ECO) : ", ...ctx.overviewLeftConfig },
                { value: data[3][1], ...ctx.overviewRightConfig, colSpan: 1 }
            ],
            height: ctx.overviewRowsHeight
            },
            {
            cells:[
                { value: "TOTAL de Excesos de Velocidad(CAN) : ", ...ctx.overviewLeftConfig },
                { value: data[3][2], ...ctx.overviewRightConfig, colSpan: 1 }
            ],
            height: ctx.overviewRowsHeight
            },
        );

        if (data[2].fatiga) {
            rows.push(
            {
                cells:[
                { value: "TOTAL de Fatigas : ", ...ctx.overviewLeftConfig },
                { value: data[3][3], ...ctx.overviewRightConfig, colSpan: 1 }
                ],
                height: ctx.overviewRowsHeight
            }
            );
        }
        if (data[2].fExBrusca) {
            rows.push(
            {
                cells:[
                { value: "TOTAL de Frenada Extremadamente Brusca : ", ...ctx.overviewLeftConfig },
                { value: data[3][4], ...ctx.overviewRightConfig, colSpan: 1 }
                ],
                height: ctx.overviewRowsHeight
            }
            );
        }
        if (data[2].fBrusca) {
            rows.push(
            {
                cells:[
                { value: "TOTAL de Frenada Brusca : ", ...ctx.overviewLeftConfig },
                { value: data[3][5], ...ctx.overviewRightConfig, colSpan: 1 }
                ],
                height: ctx.overviewRowsHeight
            }
            );
        }
        if (data[2].RPMAlta) {
            rows.push(
            {
                cells:[
                { value: "TOTAL RPM Alta : ", ...ctx.overviewLeftConfig },
                { value: data[3][6], ...ctx.overviewRightConfig, colSpan: 1 }
                ],
                height: ctx.overviewRowsHeight
            }
            );
        }
        if (data[2].alcoholemia) {
            rows.push(
            {
                cells:[
                { value: "TOTAL de alerta de alcohol en la sangre : ", ...ctx.overviewLeftConfig },
                { value: data[3][7], ...ctx.overviewRightConfig, colSpan: 1 }
                ],
                height: ctx.overviewRowsHeight
            }
            );
        }

        //======================= FIN RESUMEN =======================================================


        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
            column_config = [
            { width: ctx.w_item },
            ];
            if(ctx.chkDateHour){
            if(data[2].fExBrusca){ // Con el objetivo que el resumen pueda contener el texto de TOTALES en 3 columnas
                column_config.push(
                //{ width: ctx.w_date },
                //{ width: ctx.w_hour },
                { width: 120 },
                { width: 85 },
                )
            } else {
                column_config.push(
                //{ width: ctx.w_date },
                //{ width: ctx.w_hour },
                { width: 105 },
                { width: 75 },
                )
            }
            } else {
            if(data[2].fExBrusca){ // Con el objetivo que el resumen pueda contener el texto de TOTALES en 3 columnas
                column_config.push(
                //{ width: ctx.w_date_and_hour },
                { width: 205 },
                )
            } else {
                column_config.push(
                //{ width: ctx.w_date_and_hour },
                { width: 180 },
                )
            }
            }
            if(bool_col_fServidor){
            if(ctx.chkDateHour){
                column_config.push(
                { width: ctx.w_date_ini_fin },
                { width: ctx.w_hour_ini_fin },
                );
            } else {
                column_config.push(
                { width: ctx.w_date_and_hour },
                );
            }
            }

            if (bool_col_pCercano) {  column_config.push( { width: ctx.calculateColWidth(pc_cell_ch_width) } )}
            if (bool_col_velCAN) { column_config.push( { width: ctx.calculateColWidth(vel_can_cell_ch_width) } )}
            if (bool_col_velGPS) { column_config.push( { width: ctx.calculateColWidth(vel_gps_cell_ch_width) } )}
            if (bool_col_velGPS_speed) { column_config.push( { width: ctx.calculateColWidth(vel_gps_speed_cell_ch_width) } )}
            if (bool_col_velMobileye_ME460) {  column_config.push( { width: ctx.calculateColWidth(vel_mobileye_cell_ch_width) } )}

            if (bool_col_velECO) { column_config.push( { width: ctx.calculateColWidth(vel_eco_cell_ch_width) } )}
            if (bool_col_DUOT2state) { column_config.push( { width: ctx.calculateColWidth(duot2_state_cell_ch_width) } )}
            if (bool_col_RxM) {  column_config.push( { width: ctx.calculateColWidth(rev_x_min_cell_ch_width) } )}
            if (bool_col_RPMAlta) {  column_config.push( { width: ctx.calculateColWidth(rpm_alta_cell_ch_width) } )}
            if (bool_col_cNivel) {  column_config.push( { width: ctx.calculateColWidth(nivel_de_combustible_cell_ch_width) } )}
            if (bool_col_cRestante) {  column_config.push( { width: ctx.calculateColWidth(c_restante_cell_ch_width) } )}
            if (bool_col_cMotor) {  column_config.push( { width: ctx.calculateColWidth(c_motor_cell_ch_width) } )}
            if (bool_col_odometro) { column_config.push( { width: ctx.calculateColWidth(odometro_cell_ch_width) } )}
            if (bool_col_altitud) { column_config.push( { width: ctx.calculateColWidth(altitud_cell_ch_width) } )}
            if (bool_col_angulo) {  column_config.push( { width: ctx.calculateColWidth(angulo_cell_ch_width) } )}

            if (bool_col_alimentGps) { column_config.push( { width: ctx.calculateColWidth(alimentacion_gps_cell_ch_width) } )}
            if (bool_col_nivelBateria) { column_config.push( { width: ctx.calculateColWidth(nivel_bateria_cell_ch_width) } )}
            if (bool_col_nivelCobertura) {  column_config.push( { width: ctx.calculateColWidth(nivel_cobertura_cell_ch_width) } )}
            if (bool_col_temperaturaGps) {  column_config.push( { width: ctx.calculateColWidth(temperatura_gps_cell_ch_width) } )}
            if (bool_col_satelite) {  column_config.push( { width: ctx.calculateColWidth(satelite_cell_ch_width) } )}

            if (bool_col_recFacial) { column_config.push( { width: ctx.calculateColWidth(reconocimiento_facial_cell_ch_width) } )}
            if (bool_col_onOff) { column_config.push( { width: ctx.calculateColWidth(on_off_cell_ch_width) } )}
            if (bool_col_alcoholemia) {  column_config.push( { width: ctx.calculateColWidth(alcoholemia_cell_ch_width) } )}
            if (bool_col_parametros) {  column_config.push( { width: ctx.calculateColWidth(parametros_cell_ch_width) } )}
            if (bool_col_ubicacion) {  column_config.push( { width: ctx.calculateColWidth(ubicacion_cell_ch_width) } )}
            if (bool_col_referencia) { column_config.push( { width: ctx.calculateColWidth(referencia_cell_ch_width) } )}
            if (bool_col_fatiga) { column_config.push( { width: ctx.calculateColWidth(fatiga_cell_ch_width) } )}
            if (bool_col_fExBrusca) { column_config.push( { width: ctx.calculateColWidth(frenada_extrema_brusca_cell_ch_width) } )}
            if (bool_col_fBrusca) { column_config.push( { width: ctx.calculateColWidth(frenada_brusca_cell_ch_width) } )}
            if (bool_col_aBrusca) {  column_config.push( { width: ctx.calculateColWidth(acelaracion_brusca_cell_ch_width) } )}

            //==========================================


            exportFileEx.push({
            freezePane: {
            rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
            },
            columns: column_config,
            title: data[0][1],
            rows: rows
            });

            pc_cell_ch_width = "Punto Cercano".length;
            vel_can_cell_ch_width = "Velocidad".length;
            vel_gps_cell_ch_width = "Velocidad".length;
            vel_gps_speed_cell_ch_width = "Velocidad".length;
            vel_mobileye_cell_ch_width = "Velocidad".length;
            vel_eco_cell_ch_width = "Velocidad".length;
            duot2_state_cell_ch_width = "DUOT2 state".length;
            rev_x_min_cell_ch_width = "Rev.x.min".length;
            rpm_alta_cell_ch_width = "RPM Alta".length;
            nivel_de_combustible_cell_ch_width = "Combustible".length;
            c_restante_cell_ch_width = "C. Restante".length;
            c_motor_cell_ch_width = "C. Motor".length;
            odometro_cell_ch_width = "Odometro".length;
            altitud_cell_ch_width = "Altitud".length;
            angulo_cell_ch_width = "Angulo".length;

            alimentacion_gps_cell_ch_width = "Alimentación GPS".length;
            nivel_bateria_cell_ch_width = "Nivel de Batería".length;
            nivel_cobertura_cell_ch_width = "Nivel de Cobertura".length;
            temperatura_gps_cell_ch_width = "Temperatura GPS".length;
            satelite_cell_ch_width = "Satélite".length;

            reconocimiento_facial_cell_ch_width = "Reconocimiento".length;
            on_off_cell_ch_width = "On-off".length;
            alcoholemia_cell_ch_width = "Alcoholemia".length;
            parametros_cell_ch_width = "Parametros".length;
            ubicacion_cell_ch_width = "Ubicacion".length;
            referencia_cell_ch_width = "Referencia".length;
            fatiga_cell_ch_width = "Fatiga".length;
            frenada_extrema_brusca_cell_ch_width = "Extrema brusca".length;
            frenada_brusca_cell_ch_width = "Frenada".length;
            acelaracion_brusca_cell_ch_width = "Aceleracion".length;


        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
            rows.splice(0, ctx.headerRowSpan);
            rows.push(...ctx.spaceBetweenTables);
            allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************
        }

    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
        allRows[0].cells![0].colSpan = table_width;

        column_config = [
        { width: ctx.w_item },
        ];
        if(ctx.chkDateHour){
        if(bool_col_fExBrusca){ // Con el objetivo que el resumen pueda contener el texto de TOTALES en 3 columnas
            column_config.push(
            //{ width: ctx.w_date },
            //{ width: ctx.w_hour },
            { width: 120 },
            { width: 85 },
            )
        } else {
            column_config.push(
            //{ width: ctx.w_date },
            //{ width: ctx.w_hour },
            { width: 105 },
            { width: 75 },
            )
        }
        } else {
        if(bool_col_fExBrusca){ // Con el objetivo que el resumen pueda contener el texto de TOTALES en 3 columnas
            column_config.push(
            //{ width: ctx.w_date_and_hour },
            { width: 205 },
            )
        } else {
            column_config.push(
            //{ width: ctx.w_date_and_hour },
            { width: 180 },
            )
        }
        }
        if(bool_col_fServidor){
        if(ctx.chkDateHour){
            column_config.push(
            { width: ctx.w_date_ini_fin },
            { width: ctx.w_hour_ini_fin },
            );
        } else {
            column_config.push(
            { width: ctx.w_date_and_hour },
            );
        }
        }

        if (bool_col_pCercano) {  column_config.push( { width: ctx.calculateColWidth(pc_cell_ch_width) } )}
        if (bool_col_velCAN) { column_config.push( { width: ctx.calculateColWidth(vel_can_cell_ch_width) } )}
        if (bool_col_velGPS) { column_config.push( { width: ctx.calculateColWidth(vel_gps_cell_ch_width) } )}
        if (bool_col_velGPS_speed) { column_config.push( { width: ctx.calculateColWidth(vel_gps_speed_cell_ch_width) } )}
        if (bool_col_velMobileye_ME460) {  column_config.push( { width: ctx.calculateColWidth(vel_mobileye_cell_ch_width) } )}

        if (bool_col_velECO) { column_config.push( { width: ctx.calculateColWidth(vel_eco_cell_ch_width) } )}
        if (bool_col_DUOT2state) { column_config.push( { width: ctx.calculateColWidth(duot2_state_cell_ch_width) } )}
        if (bool_col_RxM) {  column_config.push( { width: ctx.calculateColWidth(rev_x_min_cell_ch_width) } )}
        if (bool_col_RPMAlta) {  column_config.push( { width: ctx.calculateColWidth(rpm_alta_cell_ch_width) } )}
        if (bool_col_cNivel) {  column_config.push( { width: ctx.calculateColWidth(nivel_de_combustible_cell_ch_width) } )}
        if (bool_col_cRestante) {  column_config.push( { width: ctx.calculateColWidth(c_restante_cell_ch_width) } )}
        if (bool_col_cMotor) {  column_config.push( { width: ctx.calculateColWidth(c_motor_cell_ch_width) } )}
        if (bool_col_odometro) { column_config.push( { width: ctx.calculateColWidth(odometro_cell_ch_width) } )}
        if (bool_col_altitud) { column_config.push( { width: ctx.calculateColWidth(altitud_cell_ch_width) } )}
        if (bool_col_angulo) {  column_config.push( { width: ctx.calculateColWidth(angulo_cell_ch_width) } )}

        if (bool_col_alimentGps) { column_config.push( { width: ctx.calculateColWidth(alimentacion_gps_cell_ch_width) } )}
        if (bool_col_nivelBateria) { column_config.push( { width: ctx.calculateColWidth(nivel_bateria_cell_ch_width) } )}
        if (bool_col_nivelCobertura) {  column_config.push( { width: ctx.calculateColWidth(nivel_cobertura_cell_ch_width) } )}
        if (bool_col_temperaturaGps) {  column_config.push( { width: ctx.calculateColWidth(temperatura_gps_cell_ch_width) } )}
        if (bool_col_satelite) {  column_config.push( { width: ctx.calculateColWidth(satelite_cell_ch_width) } )}

        if (bool_col_recFacial) { column_config.push( { width: ctx.calculateColWidth(reconocimiento_facial_cell_ch_width) } )}
        if (bool_col_onOff) { column_config.push( { width: ctx.calculateColWidth(on_off_cell_ch_width) } )}
        if (bool_col_alcoholemia) {  column_config.push( { width: ctx.calculateColWidth(alcoholemia_cell_ch_width) } )}
        if (bool_col_parametros) {  column_config.push( { width: ctx.calculateColWidth(parametros_cell_ch_width) } )}
        if (bool_col_ubicacion) {  column_config.push( { width: ctx.calculateColWidth(ubicacion_cell_ch_width) } )}
        if (bool_col_referencia) { column_config.push( { width: ctx.calculateColWidth(referencia_cell_ch_width) } )}
        if (bool_col_fatiga) { column_config.push( { width: ctx.calculateColWidth(fatiga_cell_ch_width) } )}
        if (bool_col_fExBrusca) { column_config.push( { width: ctx.calculateColWidth(frenada_extrema_brusca_cell_ch_width) } )}
        if (bool_col_fBrusca) { column_config.push( { width: ctx.calculateColWidth(frenada_brusca_cell_ch_width) } )}
        if (bool_col_aBrusca) {  column_config.push( { width: ctx.calculateColWidth(acelaracion_brusca_cell_ch_width) } )}

        exportFileEx.push({
        freezePane: {
            rowSplit: ctx.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
        });
    }
    //********************************************* excel version 2 *********************************

    console.log("===>exportFileEx getFileExportGeneral", exportFileEx);  

    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }
}
